import { useEffect, useState } from "react";
import { api, API, getToken } from "@/lib/api";
import { toast } from "sonner";
import { Trash2, Download, Archive } from "lucide-react";

export default function PhotosTab() {
  const [photos, setPhotos] = useState([]);
  const [tables, setTables] = useState([]);
  const [filter, setFilter] = useState("");
  const token = getToken();

  const load = async (f = filter) => {
    const { data } = await api.get("/admin/photos", { params: f ? { table_code: f } : {} });
    setPhotos(data);
  };

  useEffect(() => {
    api.get("/admin/tables").then(({ data }) => setTables(data));
    load("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const changeFilter = (v) => {
    setFilter(v);
    load(v);
  };

  const remove = async (p) => {
    if (!window.confirm("Ta bort detta foto?")) return;
    await api.delete(`/admin/photos/${p.id}`);
    toast.success("Foto borttaget");
    load();
  };

  const exportUrl = `${API}/admin/photos/export?auth=${token}${filter ? `&table_code=${filter}` : ""}`;

  return (
    <div>
      <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
        <div className="flex items-center gap-3">
          <h2 className="font-serif-d text-xl font-semibold">Foton ({photos.length})</h2>
          <select className="input-line font-sans-d text-sm w-auto" value={filter} onChange={(e) => changeFilter(e.target.value)} data-testid="photo-table-filter">
            <option value="">Alla bord</option>
            {tables.map((t) => (
              <option key={t.id} value={t.code}>
                {t.name}
              </option>
            ))}
          </select>
        </div>
        <a className="btn-invite text-[0.6rem] px-4 py-2 no-underline" href={exportUrl} data-testid="download-all-btn">
          <Archive className="w-3.5 h-3.5" /> Ladda ner alla (ZIP)
        </a>
      </div>

      {photos.length === 0 ? (
        <p className="text-sm italic text-center py-12" style={{ color: "var(--ink-soft)" }}>
          Inga foton uppladdade ännu.
        </p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
          {photos.map((p) => (
            <div key={p.id} className="group relative aspect-square overflow-hidden" style={{ border: "1px solid rgba(212,185,160,0.5)", backgroundColor: "#fff" }} data-testid={`photo-card-${p.id}`}>
              <img src={`${API}/admin/photos/${p.id}/file?auth=${token}`} alt={p.table_name} className="w-full h-full object-cover" loading="lazy" />
              <div className="absolute inset-x-0 bottom-0 p-2 flex items-end justify-between opacity-0 group-hover:opacity-100 transition-opacity" style={{ background: "linear-gradient(transparent, rgba(46,42,39,0.75))" }}>
                <div className="text-[0.6rem] text-white leading-tight">
                  <p>{p.table_name}</p>
                  <p className="opacity-75">{new Date(p.created_at).toLocaleString("sv-SE", { dateStyle: "short", timeStyle: "short" })}</p>
                </div>
                <div className="flex gap-1">
                  <a href={`${API}/admin/photos/${p.id}/file?auth=${token}&download=true`} className="p-1.5 text-white hover:opacity-70" title="Ladda ner" data-testid={`download-photo-${p.id}`}>
                    <Download className="w-4 h-4" />
                  </a>
                  <button onClick={() => remove(p)} className="p-1.5 text-white hover:opacity-70" title="Ta bort" data-testid={`delete-photo-${p.id}`}>
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
